// ============================================================================
// ISSUES MANAGER CONSTANTS
// ============================================================================
// Color mappings and configuration for Issues Manager module
// Module: 3.0 - System Operations
// ============================================================================

export const SEVERITY_COLORS = {
  critical: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  high: "bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-500/20",
  medium: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
  low: "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/20",
} as const;

export const STATUS_COLORS = {
  open: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
  investigating: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20",
  fix_in_progress: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20",
  review: "bg-purple-500/10 text-purple-700 dark:text-purple-400 border-purple-500/20",
  user_final_verify: "bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-500/20",
  closed: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20",
  wont_fix: "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/20",
  duplicate: "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/20",
  deferred: "bg-slate-500/10 text-slate-700 dark:text-slate-400 border-slate-500/20",
  rework: "bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/20",
} as const;

export const PRIORITY_COLORS = {
  p0: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  p1: "bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-500/20",
  p2: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
  p3: "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/20",
} as const;

export const MODULE_OPTIONS = [
  "Client Manager",
  "Deal Builder",
  "Lender Manager",
  "Partner Manager",
  "Securities Manager",
  "Issues Manager",
  "Control Center",
  "Project Manager",
  "Infrastructure",
  "Security",
  "Security Manager",        // NEW: ISSUE-161
  "Business Analytics",      // NEW: ISSUE-161
] as const;

export const SEVERITY_LABELS = {
  critical: "Critical",
  high: "High",
  medium: "Medium",
  low: "Low",
} as const;

export const STATUS_LABELS = {
  open: "Open",
  investigating: "Investigating",
  fix_in_progress: "Fix In Progress",
  review: "Review",
  user_final_verify: "Awaiting User Verification",
  closed: "Closed",
  wont_fix: "Won't Fix",
  duplicate: "Duplicate",
  deferred: "Deferred",
  rework: "Rework",
} as const;

export const PRIORITY_LABELS = {
  p0: "P0 - Urgent",
  p1: "P1 - High",
  p2: "P2 - Medium",
  p3: "P3 - Low",
} as const;

export const ENVIRONMENT_LABELS = {
  local: "Local",
  ci: "CI",
  staging: "Staging",
  production: "Production",
} as const;

export const CATEGORY_LABELS = {
  typescript_type: "TypeScript Type",
  ui_ux: "UI/UX",
  database_schema: "Database Schema",
  cache_state: "Cache/State",
  validation_form: "Validation/Form",
  list_filter_search: "List/Filter/Search",
  junction_table: "Junction Table",
  integration: "Integration",
  security: "Security",
  performance: "Performance",
  documentation: "Documentation",
} as const;
